import { createContext } from 'react';

export const ThemeContext = createContext({
  theme: null,
  customizations: {},
  setTheme: () => {},
  resetTheme: () => {},
  setCustomization: () => {},
});

ThemeContext.displayName = 'ThemeContext';
